// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconSignOut: React.FC = () => {
    return (
        <svg version="1.1" width="12px" height="11px" viewBox="0 0 12.0 11.0" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <clipPath id="i0">
                    <path d="M3.75,0 C4.16484368,0 4.5,0.335859776 4.5,0.75 C4.5,1.16414022 4.16484368,1.5 3.75,1.5 L2.25,1.5 C1.83585942,1.5 1.5,1.83585978 1.5,2.25 L1.5,8.25 C1.5,8.66414094 1.83585942,9 2.25,9 L3.75,9 C4.16484368,9 4.5,9.33515596 4.5,9.75 C4.5,10.164844 4.16484368,10.5 3.75,10.5 L2.25,10.5 C1.00734365,10.5 0,9.4921875 0,8.25 L0,2.25 C0,1.00734401 1.00734365,0 2.25,0 L3.75,0 Z"></path>
                </clipPath>
                <clipPath id="i1">
                    <path d="M4.70207369,0.153478144 L8.07941757,3.34097814 C8.30441847,3.55425953 8.30441847,3.94800925 8.07941757,4.13813424 L4.70207369,7.32563424 C4.53871429,7.47980618 4.29901922,7.5219233 4.09269869,7.43330597 C3.88637817,7.34424376 3.75262034,7.14099383 3.75262034,6.91650938 L3.75046885,5.25010299 L0.75046885,5.25007939 C0.33609366,5.25007939 0,4.91422033 0,4.50007939 L0,3.00007939 C0,2.58593881 0.33585942,2.25007939 0.75046885,2.25007939 L3.75046885,2.25010299 L3.75262034,0.562602994 C3.75262034,0.338072064 3.88637817,0.134798524 4.09269869,0.045806404 C4.2989484,-0.042810916 4.53859699,-0.000693796014 4.70207369,0.153478144 Z"></path>
                </clipPath>
            </defs>
            <g transform="translate(0.0 0.25)">
                <g clip-path="url(#i0)">
                    <polygon points="0,0 4.5,0 4.5,10.5 0,10.5 0,0" stroke="none" fill="currentColor"></polygon>
                </g>
                <g transform="translate(3.7518321299999986 1.498865606013971)">
                    <g clip-path="url(#i1)">
                        <polygon
                            points="0,1.38777878e-17 8.24816824,1.38777878e-17 8.24816824,7.47911238 0,7.47911238 0,1.38777878e-17"
                            stroke="none"
                            fill="currentColor"
                        ></polygon>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconSignOut);
